import * as React from 'react';

import { AiSummaryModalDesktop } from '../../components/AiSummaryModalDesktop';
import { mockNewbuildingContacts } from '../../components/AiSummaryModalDesktop/mockNewbuildingContacts';
import type { IAiSummaryFooterActions } from '../../components/AiSummaryModalDesktop/types';
import { NewbuildingCallButton } from '../NewbuildingCallButton';
import { NewbuildingChatButton } from '../NewbuildingChatButton';

export interface IAiSummaryModalDesktopContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AiSummaryModalDesktopContainer = ({
  open,
  onOpenChange,
}: IAiSummaryModalDesktopContainerProps): React.JSX.Element => {
  const [buttonSlot, setButtonSlot] = React.useState<HTMLDivElement | null>(null);
  const [activeCallNewbuildingId, setActiveCallNewbuildingId] = React.useState<number | null>(null);

  const handleCallButtonSlotChange = React.useCallback((newbuildingId: number, slot: HTMLDivElement | null) => {
    setButtonSlot(slot);

    if (slot) {
      setActiveCallNewbuildingId(newbuildingId);
    }
  }, []);

  const activeNewbuildingContacts = mockNewbuildingContacts.find(
    newbuilding => newbuilding.newbuildingId === activeCallNewbuildingId,
  );

  const handleOpenContacts = React.useCallback(() => onOpenChange(false), [onOpenChange]);
  const handleCloseContacts = React.useCallback(() => onOpenChange(true), [onOpenChange]);

  const footerActions: IAiSummaryFooterActions[] = mockNewbuildingContacts.map(newbuilding => {
    const hasChat = [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled);

    return {
      newbuildingId: newbuilding.newbuildingId,
      chat: hasChat ? (
        <NewbuildingChatButton
          builders={newbuilding.builders}
          newbuildingId={newbuilding.newbuildingId}
          sellers={newbuilding.sellers}
          size="M"
          url={newbuilding.url}
        />
      ) : undefined,
    };
  });

  return (
    <>
      <AiSummaryModalDesktop
        footerActions={footerActions}
        onCallButtonSlotChange={handleCallButtonSlotChange}
        onOpenChange={onOpenChange}
        open={open}
      />
      {activeNewbuildingContacts && (
        <NewbuildingCallButton
          key={activeNewbuildingContacts.newbuildingId}
          builders={activeNewbuildingContacts.builders}
          buttonSlot={buttonSlot}
          newbuildingId={activeNewbuildingContacts.newbuildingId}
          onCloseContacts={handleCloseContacts}
          onOpenContacts={handleOpenContacts}
          sellers={activeNewbuildingContacts.sellers}
          size="M"
          url={activeNewbuildingContacts.url}
        />
      )}
    </>
  );
};
